/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Modality = {
    Photons: 'Photons',
    Electrons: 'Electrons',
    Cobalt: 'Cobalt',
    Protons: 'Protons',
    Neutrons: 'Neutrons',
    Carbon12Ions: 'Carbon12Ions',
    HeavyParticles: 'HeavyParticles',
    RadFluDent: 'RadFluDent',
    Ct: 'CT',
    DentPan: 'DentPan',
    Mam: 'Mam'
} as const;
export type Modality = typeof Modality[keyof typeof Modality];


export function ModalityFromJSON(json: any): Modality {
    return ModalityFromJSONTyped(json, false);
}

export function ModalityFromJSONTyped(json: any, ignoreDiscriminator: boolean): Modality {
    return json as Modality;
}

export function ModalityToJSON(value?: Modality | null): any {
    return value as any;
}

/**
 * Check if a given object implements the Modality interface.
 */
 export function instanceOfModality(value: any): value is Modality {
    return Object.values(Modality).includes(value)
}

